import * as Cookies from 'js-cookie';

import cookiesWhitelist from './cookiesWhitelist';
import {apiEndpoint} from "./apiClient";

export const jsonFromUrlQuery = () => {
  const query = window.location.search.substr(1);
  const result = {};
  const split = query.split('&');
  if (split[0] === '') return result;
  split.forEach(part => {
    const item = part.split('=');
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
};

export const validCookiesList = () => (
  cookiesWhitelist
    .reduce((obj, key) => {
      if (Cookies.get(key)) {
        return { ...obj, [key]: Cookies.get(key) };
      }
      return obj;
    }, {})
);

export const parametersFromCookiesAndQuery = () => (
  { ...jsonFromUrlQuery(), ...validCookiesList()}
);

export const urlEncodedParametersFromCookiesAndQuery = () => {
  const querySearchObject = parametersFromCookiesAndQuery();

  try {
    querySearchObject.anon_id = window.analytics.user().anonymousId();
  } catch (err) {}

  return Object.keys(querySearchObject).map(k => {
    return `${encodeURIComponent(k)}=${encodeURIComponent(querySearchObject[k])}`;
  }).join('&');
};

export const queryParametersForGoogleAuthUrl = () => {
  const cookiesAndQueryParams = urlEncodedParametersFromCookiesAndQuery();

  const redirectUrl = (window.location !== window.parent.location)
    ? `${document.referrer.split('?')[0]}#ce-quickstart`
    : `${document.location.href.split('?')[0]}#ce-quickstart`;

  return cookiesAndQueryParams ?
    `${cookiesAndQueryParams}&success_url=${(redirectUrl)}` :
    `success_url=${encodeURIComponent(redirectUrl)}`
};

export const googleAuthUrl = () => `${apiEndpoint}/services/google/auth?${queryParametersForGoogleAuthUrl()}`;

export const redirectToGoogleSSO = () => {
  if (window.location !== window.parent.location) {
    window.top.location.href = googleAuthUrl();
  } else {
    window.location.replace(googleAuthUrl());
  }
};



// WEBPACK FOOTER //
// ./src/utils.js